import SearchIcon from "@/app/assets/icons/search-alt.svg?react";
import {
  Box,
  Button,
  ButtonBase,
  FormControl,
  Stack,
  TextField,
} from "@mui/material";
import { Controller, UseFormReturn } from "react-hook-form";
import { DidoxModalFormValues } from "../types";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { DidoxDocumentsModalFilter } from "./DidoxDocumentsModalFilter";

interface Props {
  form: UseFormReturn<DidoxModalFormValues>;
  onSubmit: (data: DidoxModalFormValues) => void;
  doctype: string | string[] | null;
  isInvoiceAdded: boolean;
  isContractAdded: boolean;
  onCreateVerificationAct: () => void;
  onCreateFounderProtocol: () => void;
  resetFilters: () => void;
}

export const DidoxDocumentsModalTopContent: FC<Props> = ({
  form,
  onSubmit,
  doctype,
  isInvoiceAdded,
  isContractAdded,
  onCreateVerificationAct,
  onCreateFounderProtocol,
  resetFilters,
}) => {
  const { t } = useTranslation();
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      spacing={2}
      mt={1}
    >
      <FormControl
        component="form"
        onSubmit={form.handleSubmit(onSubmit)}
        fullWidth
      >
        <Controller
          control={form.control}
          name="search"
          render={({ field }) => (
            <TextField
              {...field}
              label={t("search_on_doc_number")}
              fullWidth
              InputProps={{
                sx: {
                  paddingRight: 0,
                },
                endAdornment: (
                  <ButtonBase
                    type="submit"
                    sx={({ palette }) => ({
                      backgroundColor: palette.primary.main,
                      height: 40,
                      width: 40,
                      zIndex: 1,
                      borderTopRightRadius: 7,
                      borderBottomRightRadius: 7,
                    })}
                  >
                    <Box
                      component={SearchIcon}
                      sx={{
                        "& g": {
                          opacity: 1,
                        },
                        "& path": {
                          stroke: "white",
                        },
                      }}
                    />
                  </ButtonBase>
                ),
              }}
            />
          )}
        />
      </FormControl>
      <Stack direction="row" spacing={1.5} flexShrink={0}>
        <DidoxDocumentsModalFilter
          form={form}
          onSubmit={onSubmit}
          resetFilters={resetFilters}
        />
        {doctype === "052" && isInvoiceAdded && isContractAdded && (
          <Button onClick={onCreateVerificationAct}>
            {t("create_verification_act")}
          </Button>
        )}
        {doctype === "075" && (
          <Button onClick={onCreateFounderProtocol}>
            {t("create_founder_protocol")}
          </Button>
        )}
      </Stack>
    </Stack>
  );
};
